export const theme = {
  colors: {
    brandYellow: '#FFD100',
    slateGray: '#808080',
    deepNavy: '#000033',
    softGray: '#E0E0E0',
    white: '#FFFFFF',
    black: '#000000',
    background: '#F8F8F8'
  },
  typography: {
    headingFont: "'Poppins', sans-serif",
    bodyFont: "'Inter', sans-serif",
    fontSizes: {
      small: '10px',
      regular: '12px',
      medium: '14px',
      large: '16px',
      xlarge: '18px'
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%'
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)'
  }
};
